import React from 'react';
import PropTypes from 'prop-types';

import { UserMenuDropdown } from './user-menu-dropdown';
import { useLoginUrl } from '../useLoginUrl';
import { UserMenuButton } from './user-menu-button';
import { LoggedInUserPropType } from '@src/components/prop-types/user';

export function UserMenu({ user, isMerchant, navPages, signOut, isPrivateEnabled, isMerchantRestrictedOnly }) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const buyerUserNavPages = [
        { id: 'favorites', label: 'Favourites', href: '/wishlist', mobileOnly: false },
        { id: 'your-tasks', label: 'Your Tasks', href: '/purchase/history', mobileOnly: false },
        { id: 'your-quotes', label: 'Your Quotes', href: '/quotation/list', mobileOnly: false },
        { id: 'profile', label: 'Profile', href: '/users/settings' },
        { id: 'logout', label: 'Logout', href: '#' }
    ];

    const merchantUserNavPages = [
        { id: 'favorites', label: 'Favourites', href: '/wishlist', mobileOnly: false },
        { id: 'your-tasks', label: 'Your Tasks', href: '/purchase/history', mobileOnly: false },
        { id: 'your-quotes', label: 'Your Quotes', href: '/quotation/list', mobileOnly: false },
        { id: 'profile', label: 'Profile', href: '/merchants/settings' },
        { id: 'logout', label: 'Logout', href: '#' }
    ];

    const userNavPages = isMerchant ? merchantUserNavPages : buyerUserNavPages;

    const toggleMenu = event => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const loginUrl = useLoginUrl();

    return (
        <>
            <UserMenuButton user={user} toggleMenu={toggleMenu} loginUrl={loginUrl} />
            <UserMenuDropdown
                anchorEl={anchorEl}
                onClose={handleCloseMenu}
                navPages={navPages}
                userNavPages={userNavPages}
                user={user}
                signOut={signOut}
                loginUrl={loginUrl}
            />
        </>
    );
}

UserMenu.propTypes = {
    user: LoggedInUserPropType,
    isMerchant: PropTypes.bool,
    navPages: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            href: PropTypes.string,
            hideOnMobile: PropTypes.bool
        })
    ).isRequired,
    signOut: PropTypes.func.isRequired,
    isPrivateEnabled: PropTypes.bool,
    isMerchantRestrictedOnly: PropTypes.bool
};
